import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { of, switchMap } from 'rxjs';
import { PlatformCompanyLogoService } from '../../services/platform-company-logo.service';

@Component({
  selector: 'app-platform-company-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="logo" aria-hidden="true">
      @if (logoUrl(); as url) {
        <img [src]="url" alt="" />
      } @else {
        <span>{{ initials() }}</span>
      }
    </div>
  `,
  styleUrl: './platform-company-logo.component.scss',
  host: {
    '[class.small]': 'small()',
  },
})
export class PlatformCompanyLogoComponent {
  private readonly logos = inject(PlatformCompanyLogoService);

  readonly companyName = input.required<string>();
  readonly companyId = input<number | null>(null);
  readonly small = input(false);

  readonly initials = computed(() => {
    const parts = this.companyName()
      .split(/\s+/)
      .filter((part) => part.length > 0);
    if (parts.length === 0) {
      return '';
    }
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  });

  readonly logoUrl = toSignal(
    toObservable(this.companyId).pipe(
      switchMap((companyId) =>
        companyId == null ? of(null) : this.logos.logoUrl(companyId)
      )
    ),
    { initialValue: null }
  );
}
